import type { GiantId } from '../ids/ids';
import type { ModifierKind } from './modifiers';

/**
 * Модификатор уровня по гиганту (GDD, один на уровень).
 * Для Дракочи вместо удалённого `boiling_lake_heat` — `foam_fog`.
 * Ключи — GiantId v3.
 */
export const GIANT_LEVEL_MODIFIER: Record<GiantId, ModifierKind> = {
  svami: 'swami_leaf_overlay',
  roza: 'starfall',
  drakochi: 'foam_fog',
  yetti: 'yeti_icicle_corridor',
  mona: 'wave_surge',
  duck: 'screen_shake',
  serj: 'serge_hypnosis',
  factor: 'factor_mirage',
  willy: 'willy_blur',
  sol: 'solar_ray',
  mu: 'proximity_visibility',
};

export function getModifierForGiant(giantId: GiantId): ModifierKind {
  return GIANT_LEVEL_MODIFIER[giantId];
}
